import {
    ChecklistItem,
    ChecklistItemOrigin,
    ChecklistItemStatus,
    DocumentOrigin,
    DocumentType,
    Signer
} from 'generated/credit-analysis-graphql';
import { getKeyByValue } from 'utils/utils';

function getPendingType(items: ChecklistItem[]) {
    return items
        .filter(({ status }) => status === ChecklistItemStatus.Pending)
        .map(({ allowedDocuments }) => allowedDocuments);
}

function getPartnerWithPendingDocuments(signer: Signer[]) {
    return signer
        .find(({ checklist: { items } }) =>
        items.some(({ status, origin }) => status === ChecklistItemStatus.Pending
        && origin === ChecklistItemOrigin.UploadForm));
}

const checklistLabel = {
    [DocumentType.CertificateOfIncorporation]: {
        label: 'Contrato social',
        type: 'SocialContact'
    },
    [DocumentType.MicroBusinessesCertificate]: {
        label: 'Contrato social',
        type: 'SocialContact'
    },
    [DocumentType.CompanyBankStatement]: {
        label: 'Extratos Bancários',
        type: 'BankStatement'
    },
    [DocumentType.PartnerIdentity]: {
        label: 'Identidade',
        type: 'PartnerIdentity'
    },
    [DocumentType.PartnerDriverLicence]: {
        label: 'Identidade',
        type: 'PartnerIdentity'
    },
}

const documentName = {
    [DocumentType.CertificateOfIncorporation]: "Contrato Social",
    [DocumentType.MicroBusinessesCertificate]: "Certificado MEI",
    [DocumentType.CompanyBankStatement]: "Extrato Bancário",
    [DocumentType.PartnerIdentity]: "RG",
    [DocumentType.PartnerDriverLicence]: "CNH",
}

const getChecklistVariables = (
    loanApplicationId: string, selectedType: DocumentType, signerId?) => ({
    variables: {
        loanApplicationId,
        documentType: selectedType,
        ...(signerId &&  {signerId})
    }
})

const getSignedUrlObject = (
    filename: string,
    contentType: string,
    loanApplicationId: string,
    documentType: string,
    signerId?,
    ) => {
    const selectedType: DocumentType = DocumentType[getKeyByValue(DocumentType, documentType)]
    const filenameFormatted = filename.includes('.jfif') ? filename.replace('jfif', 'jpg'): filename

    return {
        variables: {
            loanApplicationId,
            documentType: selectedType,
            documentOrigin: DocumentOrigin.UploadedByUser,
            contentType,
            filename: filenameFormatted,
            insertUserEmail: '',
            ...(signerId &&  {signerId})
        }
    }
}

const GetAllowedDocuments = (documents: DocumentType[]) =>
    documents.map(docs => ({ label: documentName[docs], value: docs }))

export { checklistLabel,
    getPendingType,
    getPartnerWithPendingDocuments,
    documentName,
    getChecklistVariables,
    getSignedUrlObject, GetAllowedDocuments
};
